<template>
	<main id="main" class="main">
		<section class="lists">
			<div class="inner">
				<!-- 電腦版tab -->
				<div id="tablinks" class="tabs tablinks">
					<button
						v-for="(tab, index) in tabList"
						:key="`tab-${index}`"
						:class="{'active': tabActive === index}"
						class="tablink Sheet1_Click"
						@click="clickTablink(index)"
					>
						{{ tab }}
					</button>
				</div>
				<div v-if="hasArticles" class="cats tabcontent">
					<a
						v-for="(article, index) in articleData"
						:key="`${tabList[tabActive]}-${index}`"
						class="item"
						:href="article.link"
						target="_blank"
						rel="noreferrer noopener"
						@click="sendAnalytic('網友文章', article.title, tabList[tabActive])"
					>
						<div class="img">
							<img :src="article.image" :alt="article.title" />
						</div>
						<div class="description">
							<p>{{ article.title }}</p>
						</div>
					</a>
				</div>
				<div v-else class="empty-state tabcontent">
					<p>此分類的精選文章整理中，請稍後再回來查看。</p>
				</div>
			</div>
			<div
				class="hamburger"
				@click="sideMenuActive = !sideMenuActive"
			>
			</div>
			<!-- 手機版menu -->
			<div
				class="side_menu"
				:class="{ 'active': sideMenuActive }"
			>
				<div class="top">
					<div
						class="close"
						@click="sideMenuActive = !sideMenuActive"
					>
						<img src="@/assets/close.svg" />
					</div>
				</div>
				<div
					v-for="(tab, index) in tabList"
					:key="`tab-mb-${index}`"
					:class="{'active': tabActive === index}"
					class="tablink Sheet1_Click"
					@click="clickTablink(index)"
				>
					{{ tab }}
				</div>
			</div>
		</section>
		<!-- 看更多文章 -->
		<section class="more-article">
			<button class="btn-more js-more-article Content_more_click"
					v-show="hasArticles && pageOption.page < pageOption.pageTotal"
					@click="getMoreArticleData()">看更多文章</button>
		</section>
	</main>
</template>

<script setup>
import { computed, ref, reactive } from 'vue';
import sendAnalytic from '@/common/sendAnalytic';
import articleGroups from '@/data/articles';

const tabList = ['部落客實測體驗分享', '慷碩生醫林口中心參訪體驗', 'PIXNET網友好評推薦'];
const tabActive = ref(0);
const sideMenuActive = ref(false);
const pageSize = 9;

/** 頁數控制
 * @param {number} page 當前頁數
 * @param {number} pageSize 一頁幾筆資料
 */
const pageOption = reactive({
	page: 1,
	pageTotal: 1
})

const currentArticles = computed(() => articleGroups[tabList[tabActive.value]] ?? []);
const articleData = computed(() => currentArticles.value.slice(0, pageOption.page * pageSize));
const hasArticles = computed(() => currentArticles.value.length > 0);

const updatePagination = () => {
	pageOption.pageTotal = Math.max(1, Math.ceil(currentArticles.value.length / pageSize));
}

const clickTablink = id => {
	tabActive.value = id;
	sideMenuActive.value = false;
	pageOption.page = 1;
	updatePagination();
}

const getMoreArticleData = () => {
	if (pageOption.page >= pageOption.pageTotal) {
		return;
	}

	pageOption.page++;
	sendAnalytic('功能按鈕', '看更多文章點擊');
}

updatePagination();

</script>
